












import Vue from 'vue'
import isEqual from 'lodash.isequal'

export interface ToggleListItem {
  label: string
  value: any
}

export default Vue.extend({
  name: 'ToggleList',
  components: {},
  props: {
    items: {
      type: Array as () => string[],
      required: true,
    },
    value: {
      type: [String, Number, Boolean, Array, Object],
      required: true,
    },
  },
  methods: {
    isCurrentValue(value: any) {
      return isEqual(this.value, value)
    },
    onChange(value: any) {
      if (this.isCurrentValue(value)) return
      this.$emit('onChange', value)
    },
  },
})
